<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mB12ip/tc-custom/9781611521399.jpg?1723405006576" alt="This image is the cover for the book Gangster Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gangster Love
      </h1>
      <p class="bookDescription body article font2">
        <p>Short chapbook of 24 poems which center around outlaws, gangsters, robbers, gunslingers, and thieves. On loving criminals in spite of, and sometimes because of, their crimes. Set in the Old West or Small Town America, each poem is a story of love. Think Billy the Kid and Pat Garrett, or Bonnie and Clyde ... these poems celebrate the allure and romance in such doomed relationships.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.T. Marie
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JMS Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15daa082